import { WBBox, WBTypography } from '@admiin-com/ds-web';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useDefaultValueForFromTo } from '../../../features/providers/TaskCreationProvider/TaskCreationProvider';
import { Bill } from '../../PayBill/PayBillCreateForm';
import { PayFormSwitch } from './PayFormSwitch';
import { TaxPaymentRadioButtons } from './TaxPaymentRadioButtons';
import { TaskSettlementStatus } from '@admiin-com/ds-graphql';
import { useTaskCreationContext } from '../../../features/providers/TaskCreationProvider/useTaskCreationContext';
import { BillPayForm } from '../../PayBill/Review/BillPayForm';
import { useTranslation } from 'react-i18next';
export const SignaturePayForm = ({
  scannedTax,
}: {
  scannedTax: Bill | null;
}) => {
  const [showForm, setShowForm] = React.useState(false);

  const { control, setValue } = useFormContext();
  const { t } = useTranslation();
  const entity = useDefaultValueForFromTo();
  const { taskDirection, taskType } = useTaskCreationContext();
  const isNonAbnEntity = !entity?.taxNumber;
  const isTaxType = taskType === 'tax';
  const futureTaskInput = useWatch({
    name: 'futureTaskInput',
  });

  const hasFutureTaskInput =
    futureTaskInput && Object.keys(futureTaskInput).length > 0;

  React.useEffect(() => {
    if (hasFutureTaskInput) {
      setShowForm(true);
    } else {
      setShowForm(false);
    }
  }, [hasFutureTaskInput]);

  const handleSettlementStatusChange = (
    value: TaskSettlementStatus,
    onChangeField: (value: TaskSettlementStatus) => void
  ) => {
    if (taskDirection === 'SENDING' && isNonAbnEntity) return;
    onChangeField(value);
    if (value === TaskSettlementStatus.NIL) {
      setValue('futureTaskInput.amount', 0);
      setValue('futureTaskInput.lineItems', []);
    }
  };

  const onChangeFromBoolean = (value: boolean) => {
    setShowForm(value);
    if (!value) {
      setValue(
        'futureTaskInput',
        {},
        {
          shouldDirty: false,
          shouldTouch: false,
          shouldValidate: false,
        }
      );
    }
  };

  return (
    <WBBox>
      {isTaxType ? (
        <Controller
          name="settlementStatus"
          control={control}
          rules={{
            required: t('settlementStatusRequired', {
              ns: 'taskbox',
            }) as string,
          }}
          render={({ field, fieldState }) => (
            <>
              <TaxPaymentRadioButtons
                value={field.value}
                onChange={(value) =>
                  handleSettlementStatusChange(value, field.onChange)
                }
              />
              {fieldState.error && (
                <WBTypography color="error" variant="caption" mt={1}>
                  {fieldState.error.message}
                </WBTypography>
              )}
            </>
          )}
        />
      ) : (
        <PayFormSwitch
          value={hasFutureTaskInput}
          onChange={(value) => onChangeFromBoolean(value)}
          disabled={taskDirection === 'SENDING' && isNonAbnEntity}
        />
      )}
      {(isTaxType || showForm) && (
        <BillPayForm isNonAbnEntity={isNonAbnEntity} scannedTax={scannedTax} />
      )}
    </WBBox>
  );
};
